import React from 'react'
import Fortune from './components/Fortune'

function App() {
  return <Fortune />
}

export default App
